<template>
  <v-container fluid class="d-flex align-center justify-center fill-height">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="4">
        <v-card class="pa-5" elevation="3">
          <v-card-title class="text-center">{{ $t('message.login') }}</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                :label="$t('message.email')"
                prepend-icon="mdi-email"
                v-model="email"
                type="email"
                :rules="[rules.required, rules.email]"
                required
              ></v-text-field>

              <v-text-field
                :label="$t('message.password')"
                prepend-icon="mdi-lock"
                v-model="password"
                type="password"
                :rules="[rules.required]"
                required
              ></v-text-field>

              <div class="d-flex justify-center align-center" style="gap: 1vw; margin-top: 16px;">
                <!-- <v-row>
                  <v-col cols="3"></v-col>
                  <v-col cols="6">
                    <v-btn color="primary" @click="login">
                      {{ $t('message.login') }}
                    </v-btn>
                    <v-btn text color="secondary" @click="goToRegister">
                      {{ $t('message.register') }}
                    </v-btn>
                  </v-col>
                  <v-col cols="3">
                    <router-link to="/forgot-password">Forget Password?</router-link>
                  </v-col>
                </v-row> -->
                <v-btn color="primary" @click="login">
                  {{ $t('message.login') }}
                </v-btn>
                <v-btn text color="secondary" @click="goToRegister">
                  {{ $t('message.register') }}
                </v-btn>
                <router-link to="/forgot-password" style="float: right;">{{ $t('message.forgetPassword') }}</router-link>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar for success message -->
    <v-snackbar
      v-model="snackbarSuccess"
      color="success"
      top
      multi-line
      timeout="1000"
    >
      {{ successMessage }}
      <template v-slot:actions>
      <v-btn color="white" text @click="snackbarSuccess = false">Close</v-btn>
      </template>
    </v-snackbar>

    <!-- Snackbar for login error -->
    <v-snackbar
      v-model="snackbarError"
      color="error"
      top
      multi-line
      timeout="1000"
    >
      {{ errorMessage }}
      <template v-slot:actions>
      <v-btn color="white" text @click="snackbarError = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      email: '',
      password: '',
      valid: false,
      snackbarSuccess: false,
      snackbarError: false,
      successMessage: '',
      errorMessage: '',
      rules: {
        required: value => !!value || 'Required.',
        email: value => /.+@.+\..+/.test(value) || 'E-mail must be valid.',
      },
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'username']),
  },
  methods: {
    ...mapActions(['login', 'logout', 'fetchLoginStatus']),
    async login() {
      this.$refs.form.validate();
      if (this.valid) {
        try {
          const response = await axios.post('/api/user/LoginView/', {
            email: this.email,
            password: this.password,
          });

          if (response.data.access_token) {
            // 存储 Token 并更新状态
            localStorage.setItem('access_token', response.data.access_token);
            await this.fetchLoginStatus(); // 调用 Vuex 更新状态

            this.successMessage = 'Login successful!';
            this.snackbarSuccess = true;

            setTimeout(() => {
              this.$router.push({ path: '/' });
              // window.location.href = `http://qgserver.tpddns.cn:58609/#/?access_token=${response.data.access_token}`;
            }, 3000);
          }
        } catch (error) {
          console.error('Login error:', error.response ? error.response.data : error.message);
          
          // 根据不同的错误状态码显示不同的提示
          if (error.response && error.response.status === 403) {
            // 用户不存在的情况
            this.errorMessage = 'User does not exist. Please check your credentials.';
          } else {
            // 其他错误情况（密码错误、网络错误等）
            this.errorMessage = 'Invalid username or password. Please try again.';
          }
          
          this.snackbarError = true;
        }
      }
    },
    goToRegister() {
      this.$router.push('/register');
    },
    goToForgotPassword() {
      this.$router.push('/forgot-password');
    },
  },
  async mounted() {
    // 页面加载时检查登录状态
    await this.fetchLoginStatus();
  },
};
</script>
<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
